import {
  acriOnboardingABTestRouteConfig,
  getABTestConfig,
} from '@/config/abTestConfig'
import ABTestSectionOutlet from '@app-studio-web/ui/components/ABTestSectionOutlet'

export default function AcriOnboardingOutlet() {
  return (
    <ABTestSectionOutlet
      basePath="/onboarding"
      routeConfig={acriOnboardingABTestRouteConfig}
      getABTestConfig={getABTestConfig}
      validVariants={['baseline']}
    />
  )
}
